// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "-legacy." + {"132":"7c2c559f","415":"8ab381fd","418":"94b8749f","606":"24e110d1"}[chunkId] + ".js";
};